const routes = ["/admin/", "/stats/"];

export const isLegacyRoute = (r: string) => {
  for (const tr of routes) {
    if (r.indexOf(tr) === 0) {
      return true;
    }
  }
  return false;
};
